export default __webpack_public_path__ + "static/bg-menu-e0eef75b21bd241f4bffd632cc8ba221.jpg";